export const JWT_SECRET = "7kDeBYvzbD46QaJCzWpYtMxme04fzWZDZCGOP3Jp1bhlhIzw251e4xozjpUtZi86"

export const TOKEN_COOKIES = "HSTOKENID"

export const REFRESH_TOKEN_COOKIES = "HSRTKID"

export const INFO_OPTIONS = [
  "Ads Harisenin.com",
  "Content Instagram/Facebook",
  "Content Linkedin",
  "Content YouTube",
  "Content Twitter",
  "Content TikTok",
  "Event Harisenin.com",
  "Article",
  "Email",
  "Teman/Alumni",
  "Approach by Harisenin.com team",
]
